module.exports = __webpack_public_path__ + "static/media/doctor-01.04a0ed5c.jpg";